import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import {
  CreateUpdateVisitRegistrationDto,
  GetVisitRegistrationDto,
  ResponseError,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import {
  convert,
  validate,
} from '../../../common/spdCore/contexts/VisitRegistrationContext';
import { VisitRegistrationEditor } from '../../components/VisitsRegistrations/VisitRegistrationEditor';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';

export const VisitRegistrationLink = (props: {
  visitId: string;
  onRefresh?: () => void | undefined;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  externalBooking?: boolean;
}) => {
  const spd = useSpdCore();
  const [show, setShow] = useState(false);
  const [visitRegistration, setVisitRegistration] = useState<
    GetVisitRegistrationDto | null | undefined
  >();

  const handleClick = () => {
    spd.visits
      .get(props.visitId)
      .then((o: GetVisitRegistrationDto) => {
        setVisitRegistration(o);
      })
      .catch(() => {
        console.error('Error during get visit registration.');
      });
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleSubmit = async (
    visitCU: CreateUpdateVisitRegistrationDto,
    id?: string,
  ) => {
    const status = await validate(visitCU);
    if (status.valid) {
      try {
        if (id) {
          await spd.visits.update(id, visitCU);
        } else {
          await spd.visits.create(visitCU);
        }
        props.onRefresh?.();
        handleClose();
        return {
          saved: true,
          errors: [],
        };
      } catch (response) {
        return {
          saved: false,
          errors: await responseErrors(response as ResponseError),
        };
      }
    } else {
      return {
        saved: false,
        errors: status.errors,
      };
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <span onClick={e => e.stopPropagation()}>
      <OverlayTrigger overlay={<Tooltip>Podgląd rejestracji wizyty</Tooltip>}>
        <Button
          onClick={e => {
            e.stopPropagation();
            handleClick();
          }}
          variant="btn-info"
        >
          {props.icon ? <props.icon /> : <Icon.Eye />}
        </Button>
      </OverlayTrigger>
      {props.externalBooking && (
        <OverlayTrigger overlay={<Tooltip>Zapis zewnętrzny</Tooltip>}>
          <Icon.FolderSymlinkFill className="ms-1 icon-blue" size={16} />
        </OverlayTrigger>
      )}
      {visitRegistration && (
        <VisitRegistrationEditor
          id={visitRegistration?.id}
          visitRegistration={convert(visitRegistration)}
          creatorName={visitRegistration.creatorName ?? undefined}
          payments={visitRegistration.payments ?? undefined}
          examType={visitRegistration.examType ?? undefined}
          show={show}
          onCancel={handleClose}
          onSubmit={handleSubmit}
          addVisit={true}
        />
      )}
    </span>
  );
};
